/**
 * useUploadRitualImage Hook
 * Mutation hook for uploading ritual images
 */

import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"
import { uploadRitualImage } from "../services/ritual.service"

interface UploadRitualImageVariables {
  ritualId: string
  file: File
}

export function useUploadRitualImage() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ ritualId, file }: UploadRitualImageVariables) =>
      uploadRitualImage(ritualId, file),

    onSuccess: () => {
      // Invalidate ritual query to refetch
      queryClient.invalidateQueries({
        queryKey: ["ritual"],
      })
      toast.success("Image uploaded successfully")
    },

    onError: () => {
      toast.error("Failed to upload image")
    },
  })
}
